// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"488":"97d361a1fabfaff33241","532":"7ea257594c81849b51b2","592":"948f2371ffa9b8f89225","710":"6ac15cd1cc3aee6c73c9","736":"f5adb52314d8bfa36f75"}[chunkId] + ".js";
};